import { Link } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

// Shared layout for the 5 static legal / policy pages. Each page passes a
// title, an "updated" date, and the body as React children. Keeps typography
// and spacing consistent across all of them so they feel like one document
// suite rather than five hand-written pages.
export const LegalPage = ({ title, updated, intro, children }) => (
  <div className="min-h-screen flex flex-col bg-background">
    <Header />
    <main className="flex-1 px-5 py-10 sm:py-14">
      <article className="max-w-3xl mx-auto" data-testid="legal-page">
        <Link
          to="/"
          className="inline-flex items-center text-xs text-muted-foreground hover:text-foreground mb-6"
        >
          ← Back to home
        </Link>
        <div className="text-[11px] uppercase tracking-widest text-emerald-500 font-semibold mb-2">
          Legal · Policies
        </div>
        <h1
          data-testid="legal-page-title"
          className="font-display font-bold text-3xl sm:text-4xl tracking-tight text-foreground mb-3 leading-tight"
        >
          {title}
        </h1>
        {updated && (
          <p className="text-xs text-muted-foreground mb-6">Last updated: {updated}</p>
        )}
        {intro && (
          <p className="text-base text-foreground/85 leading-relaxed mb-8">{intro}</p>
        )}
        <div className="prose-legal space-y-6 text-foreground/85 leading-relaxed text-[15px]">
          {children}
        </div>
      </article>
    </main>
    <Footer />
  </div>
);

// Lightweight section helpers — keep markup readable inside each page.
export const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display font-semibold text-xl text-foreground mt-8 mb-3">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export const SubSection = ({ title, children }) => (
  <div>
    <h3 className="font-semibold text-base text-foreground mt-4 mb-1.5">{title}</h3>
    <div className="space-y-2">{children}</div>
  </div>
);

export const BulletList = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1.5 marker:text-emerald-500">
    {items.map((it, i) => (
      <li key={i}>{it}</li>
    ))}
  </ul>
);

export default LegalPage;
